import swal from 'sweetalert';
import $ from 'jquery';
import blurJS from 'blurJS';


function initNetworkPluging(){

	/***Connection Polyfill - Start **/
	(function() {
		var oConnection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
		var sType;
		var aCallbacks = [];

		// Obviously this is not accurate.
		function fnGuessType(iBandwidth) {
			if (iBandwidth > 1) {
				return 'ethernet';
			} else if (iBandwidth > .5) {
				return 'wifi';
			} else if (iBandwidth === 0) {
				return 'none';
			} else {
				return 'cellular';
			}
		}

		// Simple function to iterate over the callbacks.
		function fnCallbackIter(fn) {
			for (var i = aCallbacks.length - 1; 0 <= i; i--) {
				fn(aCallbacks[i]);
			}
		}

		if (oConnection) {
			// API is available.
			if ('metered' in oConnection) {
				// Legacy API, create obfuscation polyfill.
				sType = fnGuessType(oConnection.bandwidth);

				// If the bandwidth changes drastically, execute callbacks.
				oConnection.addEventListener('change', function(event) {
					var sNewType = fnGuessType(oConnection.bandwidth);
					if (sType !== sNewType) {
						sType = sNewType;
						fnCallbackIter(function(fnCallback) {
							fnCallback.call(navigator.connection, event);
						});
					}
				});

				navigator.connection = {
					addEventListener: function(sName, fnCallback) {
						var bFoundCallback = false;
						if (sName === 'typechange') {
							// Assert the callback doesn't exist before appending.
							fnCallbackIter(function(fnCallbackInner) {
								if (fnCallback === fnCallbackInner) {
									bFoundCallback = true;
								}
							});
							if (!bFoundCallback) {
								console.log('1');
								aCallbacks.push(fnCallback);
							}
						} else {
							// Some other event... pass through.
							oConnection.addEventListener.apply(this, arguments);
						}
					},
					removeEventListener: function(sName, fnCallback) {
						var aNewCallbacks = [];
						if (sName === 'typechange') {
							if (fnCallback) {
								// Create a new list of callbacks without the provided one.
								aNewCallbacks = [];
								fnCallbackIter(function(fnCallbackInner) {
									if (fnCallback !== fnCallbackInner) {
										aNewCallbacks.push(fnCallbackInner);
									}
								});
							}
							aCallbacks = aNewCallbacks;
							console.log(aCallbacks);
						} else {
							// Some other event... pass through.
							oConnection.addEventListener.apply(this, arguments);
						}
					},
					type: 'unknown'
				};
			}

			// Don’t change the connection object.
		} else {
			// API doesn't exist, create empty polyfill.
			navigator.connection = {
				addEventListener: function() {},
				removeEventListener: function() {},
				type: 'unknown'
			};
		}
	}());


	/***Connection Polyfill - Ed **/

	window.Connection  = {
		UNKNOWN: "unknown",
		ETHERNET: "ethernet",
		WIFI: "wifi",
		CELL_2G: "2g",
		CELL_3G: "3g",
		CELL_4G: "4g",
		CELL:"cellular",
		NONE: "none"
	}

	function updateOnlineStatus() {
		//var condition = navigator.onLine ? "online" : "offline";
		var type = navigator.connection.type ? navigator.connection.type: navigator.connection.effectiveType;
		navigator.connection.type = type;

	}
	updateOnlineStatus();
	window.addEventListener('online',  updateOnlineStatus);
	window.addEventListener('offline', updateOnlineStatus);
}

function initGoogleAnalytics(){
	var DISABLE_GOOGLE_ANAYLYTICS = false;
	function UniversalAnalyticsPlugin(){

	}
	UniversalAnalyticsPlugin.prototype.startTrackerWithId = function(GoogleTrackingId) {
		try{

			if(!DISABLE_GOOGLE_ANAYLYTICS && window.window.device && window.window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.gtag("config", GoogleTrackingId)
			}else{
				if(!DISABLE_GOOGLE_ANAYLYTICS && window.waitForCordovaToLoad && window.ga && window.ga.startTrackerWithId){
					window.ga.startTrackerWithId(GoogleTrackingId);
				}
			}
			var sourcesWhereEventsArePropageted = "";
			sourcesWhereEventsArePropageted = "mixpanel mparticle";
			this.addCustomDimension(4, sourcesWhereEventsArePropageted);
		}catch(error){
			console.error(error);
		}
	};

	UniversalAnalyticsPlugin.prototype.setUserId = function(id) {
		try{
			if(!DISABLE_GOOGLE_ANAYLYTICS  &&window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.gtag("set", "user_id", id)
			}else{
				if(!DISABLE_GOOGLE_ANAYLYTICS){
					if(window.waitForCordovaToLoad && window.ga && window.ga.setUserId){
						window.ga.setUserId(id);
					}
				}
			}
		}catch(error){
			console.error(error);
		}
	};

	/* enables verbose logging */
	UniversalAnalyticsPlugin.prototype.debugMode = function() {
		try{
			if(!DISABLE_GOOGLE_ANAYLYTICS){
				if(window.window.device && window.window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.ga_debug = {trace: true};
			}else{
				window.ga_debug = {trace: true};
			}
		}
	}catch(error){
		console.error(error);
	}
};

UniversalAnalyticsPlugin.prototype.trackView = function(screen) {
	try{
		if("MixpanelTrebbleHelper" in window){
			window.MixpanelTrebbleHelper.track(screen,{"category":"PageDisplayed"});
		}
		if("SegmentJS" in window){
			window.window.SegmentJS.page(screen);
		}
		if(!DISABLE_GOOGLE_ANAYLYTICS){
			if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.gtag('event', 'page_view', { page: location.hash, title: screen});
			}else{
				if(window.waitForCordovaToLoad && window.ga && window.ga.trackView){
					window.ga.trackView(screen);
				}
			}
		}
		/*if(window.waitForCordovaToLoad){
			if("mixpanel" in window){
				mixpanel.track(screen,{"category":"PageDisplayed"}, function(){},function(e){console.error(e)});
			}
		}else{
			MixpanelJS.track(screen,{"category":"PageDisplayed"});
		}*/
		
		if("MParticleTrebbleHelper" in window){
			window.MParticleTrebbleHelper.logPageView(screen);
		}
	}catch(error){
		console.error(error);
	}
};

UniversalAnalyticsPlugin.prototype.addCustomDimension = function(key, value) {
	try{
		if(!DISABLE_GOOGLE_ANAYLYTICS){
			if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad && window.window.gtag_custom_map){
				var dimemsionName = window.window.gtag_custom_map["dimension"+ key];
				if(dimemsionName){
					window.gtag('event', 'custom_dimension_event', {dimemsionName: value});
				}
			}else{
				if(window.waitForCordovaToLoad && window.ga && window.ga.addCustomDimension){
					window.ga.addCustomDimension(key, value);
				}
			}
		}
	}catch(error){
		console.error(error);
	}
};

UniversalAnalyticsPlugin.prototype.addCustomMetric = function(key, value) {
	try{
		if(!DISABLE_GOOGLE_ANAYLYTICS){
			if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				var metricName = window.window.gtag_custom_map["metric"+ key];
				if(metricName){
					window.gtag('event', 'custom_metric_event', {metricName: value});
				}
			}else{
				if(window.waitForCordovaToLoad && window.ga && window.ga.trackMetric){
					window.ga.trackMetric(key, value);
				}
			}
		}
	}catch(error){
		console.error(error);
	}
};

UniversalAnalyticsPlugin.prototype.trackEvent = function(category, action, label, value, additionalKeyValueMap) {
	try{

	

		var paramsToSend = additionalKeyValueMap && typeof additionalKeyValueMap !== "string"? additionalKeyValueMap :{"additionalKeyValueMapString": additionalKeyValueMap};
		paramsToSend.category = category;
		paramsToSend.label = label;
		if(value){
			paramsToSend.value = value;
		}
		/*if(window.waitForCordovaToLoad){
			if("mixpanel" in window){
				mixpanel.track(action,paramsToSend, function(){},function(e){console.error(e)});
			}
		}else{
			MixpanelJS.track(action,paramsToSend);
		}*/

		if("MixpanelTrebbleHelper" in window){
			window.MixpanelTrebbleHelper.track(action,paramsToSend);
		}

		if("SegmentJS" in window){
			window.window.SegmentJS.track(action,paramsToSend);
		}


		if("MParticleTrebbleHelper" in window){
			var paramToSendFormattedForMparticle = null;
			if(paramsToSend){
				paramToSendFormattedForMparticle =  {};
				for(var key in paramsToSend){
					var valueToSend = paramsToSend[key];
					if(typeof(valueToSend)== "string" || typeof(valueToSend)== "number" || typeof(valueToSend)== "boolean" || valueToSend instanceof Date){
						paramToSendFormattedForMparticle[key] = valueToSend;
					}
				}
			}
			window.MParticleTrebbleHelper.logEvent(label, window.MParticleTrebbleHelper.EventType.Other, paramToSendFormattedForMparticle,{"Google.Category":category,"Google.Label":label,"Google.alue":value});
		}

		try{

			if("FeatureRolloutHelper" in window && "trebbleIntercomHelper" in window && window.FeatureRolloutHelper.isFeatureEnabled(window.FeatureRolloutHelper.FEATURES.TURN_ON_SENDING_SOME_EVENTS_TO_INTERCOM)){
				var eventsAllowedString = window.FeatureRolloutHelper.getFeatureVariable(window.FeatureRolloutHelper.FEATURES.TURN_ON_SENDING_SOME_EVENTS_TO_INTERCOM, window.FeatureRolloutHelper.FEATURES.TURN_ON_SENDING_SOME_EVENTS_TO_INTERCOM.variables.events_to_send, true);
				if(eventsAllowedString){
					var eventsAllowedArray = eventsAllowedString.split(",");
					if(eventsAllowedArray.indexOf(label) != -1){
						window.trebbleIntercomHelper.trackEvent(label, paramsToSend)
					}
				}
			}
		}catch(error){
			console.error(error)
		}

		if("FeatureRolloutHelper" in window){
			window.FeatureRolloutHelper.track(action);
		}

		if (typeof label === 'undefined' || label === null) {
			label = '';
		}
		if (typeof value === 'undefined' || value === null) {
			value = 0;
		}
		if(!DISABLE_GOOGLE_ANAYLYTICS){
			if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.gtag('event', action,  {
					'eventCategory': category,   // Required.
					'eventAction': action,      // Required.
					'eventLabel': label,
					'eventValue': Number.isInteger(value)?value: 0
				});
			}else{
				if(window.waitForCordovaToLoad && window.ga && window.ga.trackEvent){
					window.ga.trackEvent(category, action,label, value);
				}
			}
		}
	}catch(error){
		console.error(error);
	}
};

/**
* https://developers.google.com/analytics/devguides/collection/android/v3/exceptions
*/
UniversalAnalyticsPlugin.prototype.trackException = function(description, fatal) {
	try{
		if(!DISABLE_GOOGLE_ANAYLYTICS){
			if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
				window.gtag('event', 'exception', {
					'description':description,
					'fatal': fatal 
				});
			}else{
				if(window.waitForCordovaToLoad && window.ga && window.ga.trackException){
					window.ga.trackException(description, fatal);
				}
			}
		}
	}catch(error){
		console.error(error);
	}
};
/*
UniversalAnalyticsPlugin.prototype.trackTiming = function(category, intervalInMilliseconds, name, label) {
	try{
		if(false){

			

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.track(name,{"category":category,"timeTracking":true, "timeIntervalInMilliseconds":intervalInMilliseconds,"label":label});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track(name,{"category":category,"timeTracking":true, "timeIntervalInMilliseconds":intervalInMilliseconds,"label":label});
			}

			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent(label, window.MParticleTrebbleHelper.EventType.Other, {"category":category,"label":label},{"Google.Category":category,"Google.Label":label,"Google.UserTiming":intervalInMilliseconds});
			}
			if(!DISABLE_GOOGLE_ANAYLYTICS){
				if (typeof intervalInMilliseconds === 'undefined' || intervalInMilliseconds === null) {
					intervalInMilliseconds = 0;
				}
				if (typeof name === 'undefined' || name === null) {
					name = '';
				}
				if (typeof label === 'undefined' || label === null) {
					label = '';
				}
				if(window.device && window.device.platform =="browser" && window.window.gtag && !window.waitForCordovaToLoad){
					window.gtag('event', 'timing_complete', {
						'name': 'timingVar',
						'value': intervalInMilliseconds,
						'event_category': category,
						'event_label': label
					});
				}else{
					if(window.waitForCordovaToLoad && window.ga && window.ga.trackTiming){
						window.ga.trackTiming(category, intervalInMilliseconds, name, label);
					}
				}
			}
		}
	}catch(error){
		console.error(error);
	}
};*/
UniversalAnalyticsPlugin.prototype.trackTiming = function(){};

UniversalAnalyticsPlugin.prototype.trebbleHelperSetTemporary = function(temporary, uniqueUserIdentifier){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.registerSuperProperties({"userStatus": temporary? "Visitor": "Registered"}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.register({"userStatus": temporary? "Visitor": "Registered"});
	}*/

	if("MixpanelTrebbleHelper" in window){
		//window.MixpanelTrebbleHelper.registerSuperProperties({"userStatus": temporary? "Visitor": "Registered"});
		if(temporary){
			window.MixpanelTrebbleHelper.reset();
		}
		if(!temporary && uniqueUserIdentifier){
			window.MixpanelTrebbleHelper.identify(uniqueUserIdentifier);
		}
		window.MixpanelTrebbleHelper.registerSuperProperties({"userStatus": temporary? "Visitor": "Registered","uniqueUserIdentifier": uniqueUserIdentifier});
	}

	if("SegmentJS" in window){
		window.SegmentJS.identify({"userStatus": temporary? "Visitor": "Registered","uniqueUserIdentifier": uniqueUserIdentifier});
	}
	if("MParticleTrebbleHelper" in window){
		//window.MParticleTrebbleHelper.setUserAttributes({"userStatus": temporary? "Visitor": "Registered"});
		window.MParticleTrebbleHelper.logout();
		window.MParticleTrebbleHelper.setUserAttributes({"userStatus": temporary? "Visitor": "Registered","uniqueUserIdentifier": uniqueUserIdentifier});
	}
	this.addCustomDimension(1,temporary? "Visitor": "Registered");
	
}

UniversalAnalyticsPlugin.prototype.updateUserProperties = function(userPropertiesUpdates){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.registerSuperProperties({"userStatus": temporary? "Visitor": "Registered"}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.register({"userStatus": temporary? "Visitor": "Registered"});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.registerSuperProperties(userPropertiesUpdates);
	}

	if("SegmentJS" in window){
		window.SegmentJS.identify(userPropertiesUpdates);
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.setUserAttributes(userPropertiesUpdates);
	}
	
	
}


UniversalAnalyticsPlugin.prototype.trebbleHelperSetAppContext = function(appContext){
	//var APP_CONTEXT_TO_INDEX = {"Embedded": 0,"LiveWebsite":1,"iOSApp":2,"androidApp": 3, "Development": 4};
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.registerSuperProperties({"appContext": appContext}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.register({"appContext": appContext});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.registerSuperProperties({"appContext": appContext});
	}

	if("SegmentJS" in window){
		window.SegmentJS.identify({"appContext": appContext});
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.setUserAttributes({"appContext": appContext});
	}
	this.addCustomDimension(2,appContext);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperSetAppTimestampVersion = function(unixVersion, buildHash){
	// AppTimestampVersion is our deploy-tracing identifier, while AppBuildHash
	// preserves the underlying webpack hash for lower-level debugging.
	var analyticsProperties = {"AppTimestampVersion": unixVersion};
	if(buildHash){
		analyticsProperties.AppBuildHash = buildHash;
	}
	
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.registerSuperProperties({"AppTimestampVersion": unixVersion}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.register({"AppTimestampVersion": unixVersion});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.registerSuperProperties(analyticsProperties);
	}

	if("SegmentJS" in window){
		window.SegmentJS.identify(analyticsProperties);
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.setUserAttributes(analyticsProperties);
	}
	this.addCustomDimension(5,unixVersion);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperSetEventEmitter = function(){
	//This dimension is used to be able to track which framework is used to send event to google analytics and differentiate between event created directly from Google Analytics and events that are not
	if("SegmentJS" in window){
		window.SegmentJS.identify({"EventEmitter": "SegmentJS"});
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.setUserAttributes({"EventEmitter": "MParticle"});
	}
	this.addCustomDimension(3,"GoogleAnalytics");
}


UniversalAnalyticsPlugin.prototype.trebbleHelperTrackCapsuleCreated = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"capsuleCreated": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"capsuleCreated": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"capsuleCreated": 1});
	}


	if("SegmentJS" in window){
		window.window.SegmentJS.track("capsuleCreated");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("capsuleCreated", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"capsuleCreated","Google.Label":"Capsule Created", "Google.Value":1});
	}

	this.addCustomMetric(1,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackCapsuleUpdated = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"capsuleCreated": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"capsuleCreated": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"capsuleUpdated": 1});
	}


	if("SegmentJS" in window){
		window.window.SegmentJS.track("capsuleUpdated");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("capsuleUpdated", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"capsuleUpdated","Google.Label":"Capsule Updated", "Google.Value":1});
	}

	this.addCustomMetric(1,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackTrebbleListeningTime = function(listeningTimeInMilliseconds){
	if(listeningTimeInMilliseconds){
		try{
			var listeningTimeInSeconds = Math.round(parseInt(listeningTimeInMilliseconds)/1000);
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"trebbleListeningTime":listeningTimeInSeconds}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"trebbleListeningTime":listeningTimeInSeconds});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"trebbleListeningTime":listeningTimeInSeconds});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("trebbleListeningTime");
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("trebbleListeningTime", window.MParticleTrebbleHelper.EventType.Other,{"trebbleListeningTime":listeningTimeInSeconds},{"Google.Category":"trebbleListeningTime", "Google.Label":"Trebble Listening Time"});
			}
			this.addCustomMetric(11,listeningTimeInSeconds);
		}catch(error){
			console.error(error);
		}
	}
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackCaspsuleTrebbleFeedListeningTime = function(listeningTimeInMilliseconds){
	if(listeningTimeInMilliseconds){
		try{
			var listeningTimeInSeconds = Math.round(parseInt(listeningTimeInMilliseconds)/1000);
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("caspsuleTrebbleFeedListeningTime");
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("caspsuleTrebbleFeedListeningTime", window.MParticleTrebbleHelper.EventType.Other,{"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds},{"Google.Category":"caspsuleTrebbleFeedListeningTime", "Google.Label":"Capsule Trebble Feed Listening Time"});
			}
			this.addCustomMetric(12,listeningTimeInSeconds);
		}catch(error){
			console.error(error);
		}
	}
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackCaspsuleCategoryShortcastRadioListeningTime = function(listeningTimeInMilliseconds){
	if(listeningTimeInMilliseconds){
		try{
			var listeningTimeInSeconds = Math.round(parseInt(listeningTimeInMilliseconds)/1000);
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"caspsuleTrebbleFeedListeningTime":listeningTimeInSeconds});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"categoryShortcastRadioListeningTime":listeningTimeInSeconds});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("categoryShortcastRadioListeningTime");
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("categoryShortcastRadioListeningTime", window.MParticleTrebbleHelper.EventType.Other,{"categoryShortcastRadioListeningTime":listeningTimeInSeconds},{"Google.Category":"categoryShortcastRadioListeningTime", "Google.Label":"Category Shortcast Radio Listening Time"});
			}
			this.addCustomMetric(13,listeningTimeInSeconds);
		}catch(error){
			console.error(error);
		}
	}
}


UniversalAnalyticsPlugin.prototype.trebbleHelperTrackCapsuleSharedListeningTime = function(listeningTimeInMilliseconds){
	if(listeningTimeInMilliseconds){
		try{
			var listeningTimeInSeconds = Math.round(parseInt(listeningTimeInMilliseconds)/1000);
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"capsuleSharedListeningTime":listeningTimeInSeconds}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"capsuleSharedListeningTime":listeningTimeInSeconds});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"capsuleSharedListeningTime":listeningTimeInSeconds});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("capsuleSharedListeningTime");
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("capsuleSharedListeningTime", window.MParticleTrebbleHelper.EventType.Other,{"capsuleSharedListeningTime":listeningTimeInSeconds},{"Google.Category":"capsuleSharedListeningTime","Google.Label": "Capsule Shared Listening Time"});
			}
			this.addCustomMetric(3,listeningTimeInSeconds);
		}catch(error){
			console.error(error);
		}
	}
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackSongSharedListeningTime = function(listeningTimeInMilliseconds){
	if(listeningTimeInMilliseconds){
		try{

			var listeningTimeInSeconds = Math.round(parseInt(listeningTimeInMilliseconds)/1000);
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"songSharedListeningTime":listeningTimeInSeconds}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"songSharedListeningTime":listeningTimeInSeconds});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"songSharedListeningTime":listeningTimeInSeconds});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("songSharedListeningTime");
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("songSharedListeningTime", window.MParticleTrebbleHelper.EventType.Other,{"songSharedListeningTime":listeningTimeInSeconds},{"Google.Category":"songSharedListeningTime", "Google.Label": "Song Shared Listening Time"});
			}
			this.addCustomMetric(4,listeningTimeInSeconds);
		}catch(error){
			console.error(error);
		}
	}
}



UniversalAnalyticsPlugin.prototype.trebbleHelperTrackSongAddedToTrebble = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"songAddedToTrebble": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"songAddedToTrebble": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"songAddedToTrebble": 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("songAddedToTrebble");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("songAddedToTrebble", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"songAddedToTrebble", "Google.Label":"Song added to Trebble"});
	}

	this.addCustomMetric(5,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackSongRemovedToTrebble = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"songRemovedTrebble": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"songRemovedTrebble": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"songRemovedTrebble": 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("songRemovedTrebble");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("songRemovedTrebble", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"songRemovedTrebble", "Google.Label":"Song removed from Trebble"});
	}
	this.addCustomMetric(6,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackNumberOfLiveLikes = function(liveLikes){
	if(liveLikes){

		try{
			/*if(window.waitForCordovaToLoad){
				if("mixpanel" in window){
					mixpanel.people.increment({"liveLikes":liveLikes}, function(){},function(e){console.error(e)});
				}
			}else{
				MixpanelJS.people.increment({"liveLikes":liveLikes});
			}*/

			if("MixpanelTrebbleHelper" in window){
				window.MixpanelTrebbleHelper.people.increment({"liveLikes":liveLikes});
			}

			if("SegmentJS" in window){
				window.window.SegmentJS.track("liveLikes",{"count":liveLikes});
			}
			if("MParticleTrebbleHelper" in window){
				window.MParticleTrebbleHelper.logEvent("liveLikes", window.MParticleTrebbleHelper.EventType.Other,{"count":liveLikes},{"Google.Category":"liveLikes", "Google.Label": "Live Likes"});
			}
			this.addCustomMetric(7,parseInt(liveLikes));
		}catch(error){
			console.error(error);
		}
	}
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackComment = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"wroteComment": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"wroteComment": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"wroteComment": 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("wroteComment");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("wroteComment", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"wroteComment", "Google.Label": "Wrote Comment"});
	}
	this.addCustomMetric(8,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackLikeComment = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"likedComment": 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"likedComment": 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"likedComment": 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("likedComment");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("likedComment", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"likedComment","Google.Label": "Liked Comment"});
	}
	this.addCustomMetric(9,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackUnlikeComment = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"unlikedComment" : 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"unlikedComment"  : 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"unlikedComment"  : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("unlikedComment");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("unlikedComment", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"unlikedComment", "Google.Label": "Unliked Comment"});
	}
	this.addCustomMetric(10,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackSubscribeToTrebble = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"subscribeToTrebble" : 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"subscribeToTrebble" : 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"subscribeToTrebble" : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("subscribeToTrebble");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("subscribeToTrebble", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"subscribeToTrebble", "Google.Label": "Subscribe To Trebble"});
	}
	this.addCustomMetric(13,1);
}


UniversalAnalyticsPlugin.prototype.trebbleHelperTrackSubscribeToJourney = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"subscribeToTrebble" : 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"subscribeToTrebble" : 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"subscribeToJourney" : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("subscribeToJourney");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("subscribeToJourney", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"subscribeToJourney", "Google.Label": "Subscribe To Journey"});
	}
}


UniversalAnalyticsPlugin.prototype.trebbleHelperTrackUnsubscribeToTrebble = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"unsubscribeFromTrebble" : 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"unsubscribeFromTrebble" : 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"unsubscribeFromTrebble" : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("unsubscribeFromTrebble");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("unsubscribeFromTrebble", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"unsubscribeFromTrebble",  "Google.Label":"Unsubscribe From Trebble"});
	}
	this.addCustomMetric(14,1);
}

UniversalAnalyticsPlugin.prototype.trebbleHelperTrackPlayedFeedForTheDay = function(){
	/*if(window.waitForCordovaToLoad){
		if("mixpanel" in window){
			mixpanel.people.increment({"playedFeedForTheDay" : 1}, function(){},function(e){console.error(e)});
		}
	}else{
		MixpanelJS.people.increment({"playedFeedForTheDay" : 1});
	}*/

	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"playedFeedForTheDay" : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("playedFeedForTheDay");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("playedFeedForTheDay", window.MParticleTrebbleHelper.EventType.Other,null,{"Google.Category":"playedFeedForTheDay", "Google.Label": "Played Feed For The Day"});
	}
	this.addCustomMetric("15",1);
}


UniversalAnalyticsPlugin.prototype.trebbleHelperTrackPlayedShortcastCategoryPlayed = function(){


	if("MixpanelTrebbleHelper" in window){
		window.MixpanelTrebbleHelper.people.increment({"shortcastCategoryPlayed" : 1});
	}

	if("SegmentJS" in window){
		window.window.SegmentJS.track("shortcastCategoryPlayed");
	}
	if("MParticleTrebbleHelper" in window){
		window.MParticleTrebbleHelper.logEvent("shortcastCategoryPlayed", window.MParticleTrebbleHelper.EventType.Other,null);
	}
	
}

window.trebbleAnalyticsHelper =  new UniversalAnalyticsPlugin();


}



function initCamera(){
function takePicture(success, error, opts) {
	if (opts && opts[2] === 1) {
		capture(success, error);
	} else {
		var input = document.createElement('input');
		input.type = 'file';
		input.name = 'files[]';

		input.onchange = function(inputEvent) {

			var reader = new FileReader();
			reader.onload = function(readerEvent) {
				input.parentNode.removeChild(input);

				var imageData = readerEvent.target.result;

				return success(imageData.substr(imageData.indexOf(',') + 1));
			}

			reader.readAsDataURL(inputEvent.target.files[0]);
		};

		document.body.appendChild(input);
	}
}

function capture(success, errorCallback) {
	var localMediaStream;

	var video = document.createElement('video');
	var button = document.createElement('button');

	video.width = 320;
	video.height = 240;
	button.innerHTML = 'Capture!';

	button.onclick = function() {
		// create a canvas and capture a frame from video stream
		var canvas = document.createElement('canvas');
		canvas.getContext('2d').drawImage(video, 0, 0, 320, 240);

		// convert image stored in canvas to base64 encoded image
		var imageData = canvas.toDataURL('img/png');
		imageData = imageData.replace('data:image/png;base64,', '');

		// stop video stream, remove video and button
		localMediaStream.stop();
		video.parentNode.removeChild(video);
		button.parentNode.removeChild(button);

		return success(imageData);
	}

	navigator.getUserMedia = navigator.getUserMedia ||
	navigator.webkitGetUserMedia ||
	navigator.mozGetUserMedia ||
	navigator.msGetUserMedia;

	var successCallback = function(stream) {
		localMediaStream = stream;
		video.src = window.URL.createObjectURL(localMediaStream);
		video.play();

		document.body.appendChild(video);
		document.body.appendChild(button);
	}

	if (navigator.getUserMedia) {
		navigator.getUserMedia({video: true, audio: true}, successCallback, errorCallback);
	} else {
		alert('Browser does not support camera :(');
	}
}

if(!window.camera){
	window.camera = {};
}
if(!window.camera.takePicture){
	window.camera.takePicture =  takePicture;
}
}

function initDialog(){
// Platform: browser
var TREBBLE_SWEET_ALERT_CUSTOM_CLASS = "trebble_sweet_alert";
window.navigator.trebbleNotification = window.navigator.trebbleNotification || {};
var isScreenBigEnoughToDisplayDialog =function(){
	var isBigEnough =  window.innerWidth > 150 && window.innerHeight > 150;
	if(!isBigEnough){
		console.warn("this screen is not big enough to display popup");
	}
	return isBigEnough;
}

window.navigator.trebbleNotification.alert = function(message, callback, html, type, text, buttonLabel) {
	// `notification.alert` executes asynchronously
	if(isScreenBigEnoughToDisplayDialog()){
		var params = {};
		params.title = !message?"": message;
		
		// SweetAlert v1 uses html flag to control HTML rendering
		// When HTML content is provided, set html: true and use text parameter
		if(html && html !== false){
			params.text = html;  // HTML content goes in text parameter
			params.html = true;  // Enable HTML rendering
		}else if(text){
			params.text = text;
			params.html = false; // Escape HTML (default)
		}
		
		if(buttonLabel){
			params.button = buttonLabel;
		}
		params.customClass  = TREBBLE_SWEET_ALERT_CUSTOM_CLASS;
		if(type){
			params.type = type;
		}
		swal(params,callback);
	}
	/*window.alert(message);
	if (callback) {
		callback();
	}*/

};


window.navigator.trebbleNotification.confirm = function(message, callback,  title, buttonLabels, html, type, text, showLoaderOnConfirm, customImageUrl, customImageSize) {
	// `notification.confirm` executes asynchronously
	if(isScreenBigEnoughToDisplayDialog()){
		swal({   title: message, 
			text: text,  
			type: type,
			showCancelButton: buttonLabels && buttonLabels.length == 2? true: false,
			"html": html,
			confirmButtonText: buttonLabels && buttonLabels.length == 2?buttonLabels[1]:(buttonLabels && buttonLabels.length == 1?buttonLabels[0]:"Yes"),
			cancelButtonText: buttonLabels && buttonLabels.length == 2?buttonLabels[0]:(buttonLabels && buttonLabels.length == 1?null:"No"),
			closeOnConfirm: showLoaderOnConfirm? false: true, 
			showLoaderOnConfirm : showLoaderOnConfirm,
			customClass  : TREBBLE_SWEET_ALERT_CUSTOM_CLASS,
			imageUrl : customImageUrl,
			imageSize : customImageSize,
			closeOnCancel: true }, 
			function(isConfirm){  
				if (isConfirm) {  
					callback(2); 
				}else{ 
					callback(1); 
				} });
	}

};


window.navigator.trebbleNotification.prompt = function(message, callback, title, buttonLabels, defaultText, html, inputPlaceholder, defaultValue) {
	// `notification.prompt` executes asynchronously
	if(isScreenBigEnoughToDisplayDialog()){
		swal({   "title": title,
			"text": message, 
			type: "input",
			showCancelButton: true,  
			closeOnConfirm: true, 
			animation: "slide-from-top",
			"html": html,
			customClass  : TREBBLE_SWEET_ALERT_CUSTOM_CLASS,
			confirmButtonText: buttonLabels[0],
			cancelButtonText: buttonLabels[1], 
			inputValue:  defaultValue ? defaultValue: "" ,
			inputPlaceholder: inputPlaceholder ? inputPlaceholder: "" 
		}, function(inputValue){
			if (inputValue === false){
				callback({ buttonIndex: 2, input1: '' }); 
			}
			if (inputValue === "") {   
				swal.showInputError("You need to write something!"); 
			}else{
				callback({ buttonIndex: 1, input1: inputValue });
			}
		});
	}
	/* var result = window.prompt(message,  defaultText || '');
	if (callback) {
		if (result === null) {
			callback({ buttonIndex: 2, input1: '' }); // Cancel
		}
		else {
			callback({ buttonIndex: 1, input1: result }); // OK
		}
	}*/

};


window.navigator.trebbleNotification.beep = function(times) {
	if (times > 0) {
		var BEEP_DURATION = 700;
		var BEEP_INTERVAL = 300;

		if (window.audioContext) {
			// Start a beep, using the Audio API
			var osc = window.audioContext.createOscillator();
			osc.type = 0; // sounds like a "beep"
			osc.connect(window.audioContext.destination);
			osc.start(0);

			setTimeout(function() {
				// Stop the beep after the BEEP_DURATION
				osc.stop(0);

				if (--times > 0) {
					// Beep again, after a pause
					setTimeout(function() {
						navigator.notification.beep(times);
					}, BEEP_INTERVAL);
				}

			}, BEEP_DURATION);
		}
		else if (typeof(console) !== 'undefined' && typeof(console.log) === 'function') {
			// Audio API isn't supported, so just write `beep` to the console
			for (var i = 0; i < times; i++) {
				console.log('Beep!');
			}
		}
	}
};

/*var audioContext = (function() {
	// Determine if the Audio API is supported by this browser
	var AudioApi = window.AudioContext;
	if (!AudioApi) {
		AudioApi = window.webkitAudioContext;
	}

	if (AudioApi) {
		// The Audio API is supported, so create a singleton instance of the AudioContext
		return new AudioApi();
	}

	return undefined;
}());*/
}

function initMusicFileReaderPlugin(){
var DEFAULT_TIME_NOTIFICATION_STAY_OPEN_IN_MILLI_SEC = 6000;
var CONCATENATE_ARTIST_AND_ALBUM_IN_NOTIFICATION = false; 
var ASK_FOR_PERMISSION_MULTIPLE_TIMES_IN_SAME_SESSION = false;
var DISABLE_IMAGE_BLUR_BACKGROUND = false;
function retrieveBase64FromUrl (success, error, opts) {
	if(DISABLE_IMAGE_BLUR_BACKGROUND){
		return success(null);
	}
	if (opts && opts.length < 1) {
		error("Image url is missing!");
	} else {
		try{
			var url = opts[0];
			var img = new Image();
			if(url && url.indexOf("data:image") != 0){
				img.crossOrigin = 'Anonymous';
				url = window.trebble.globalHelpers.getResizeImageUrl(url,  640,640);
			}
			img.onerror = function(e){
				error(e);
			};
			img.onload = function(){
				try{
					var canvas = document.createElement('CANVAS');
					var ctx = canvas.getContext('2d');
					canvas.height = this.height;
					canvas.width = this.width;
					ctx.drawImage(this,0,0);
					var dataURL = canvas.toDataURL('image/png');
					canvas = null;
					var r = {};
					r.base64 = dataURL;
					success(r);
				}catch(e){
					error(e);
				}
			};
			img.src = url;
		}catch(e){
			error(e);
		}
	}
}

function createNotification(title,body, icon, onClick, onClose , onShow, onError){
	var notification = null;
	if (("Notification" in window)) {
		if(icon && icon.indexOf("http") == -1){
			icon = "data:image/png;base64," + icon;
		}
		notification = new Notification(title, {"body": body,"icon": icon,"onclick": onClick,"onclose": onClose,"onshow": onShow ,"onerror": onError , silent: true})	
		if(!onClick){
			onClick = function(){
				window.focus();
			}
			notification.onclick = onClick;
			notification.onshow = function(){
				setTimeout(function(){
					notification.close()
				}, DEFAULT_TIME_NOTIFICATION_STAY_OPEN_IN_MILLI_SEC);
				if(onShow){
					onShow();
				}
			};
		}
	}
	return notification;


}

function triggerEventFromDocument(eventName, params){
	try{
		document.dispatchEvent(new CustomEvent(eventName, params));

	}catch(error){
		console.error(error);
	}
}

function updateMetaData(success, error, opts){
	if (opts && opts.length < 5) {
		console.warn("Invalid number of parameter for updating meta data");
		success();
	} else {
		var songTitle = opts[0];
		var artistName = opts[1];
		var albumName = opts[2];
		//var albumId = opts[3];
		var coverArtBase64 = opts[4];
		//var albumURL = opts[5];
		var notification = null;
		triggerEventFromDocument("updateMetaData",{"detail":opts});


		if ('mediaSession' in navigator) {
			var coverArtForMediaSession = coverArtBase64;
			if(coverArtBase64 && coverArtBase64.indexOf("http") == -1){
				coverArtForMediaSession = "data:image/png;base64," + coverArtBase64;
			}
			navigator.mediaSession.metadata = new MediaMetadata({
				title: songTitle,
				artist: artistName,
				album: albumName,
				artwork: coverArtForMediaSession? [
				{ src: coverArtForMediaSession,   sizes: '96x96',   type: 'image/png' },
				{ src: coverArtForMediaSession, sizes: '128x128', type: 'image/png' },
				{ src: coverArtForMediaSession, sizes: '192x192', type: 'image/png' },
				{ src: coverArtForMediaSession, sizes: '256x256', type: 'image/png' },
				{ src: coverArtForMediaSession, sizes: '384x384', type: 'image/png' },
				{ src: coverArtForMediaSession, sizes: '512x512', type: 'image/png' },
				] : null
			});
		}

		/* Let's check if the browser supports notifications*/
		if (!("Notification" in window)) {
			//console.warn("This browser does not support desktop notification");
		}

		/*Let's check if the user is okay to get some notification*/
		else if (Notification.permission === "granted") {
			if(document.hidden){
				// If it's okay let's create a notification
				var body =  artistName ? artistName : "";
				body = (albumName && CONCATENATE_ARTIST_AND_ALBUM_IN_NOTIFICATION)? body + " - " + albumName: body;
				notification = createNotification(songTitle, body, coverArtBase64  );
			}
		}

		// Otherwise, we need to ask the user for permission
		// Note, Chrome does not implement the permission static property
		// So we have to check for NOT 'denied' instead of 'default'
		else if (Notification.permission !== 'denied') {
			/*if(false){
				//DISABLING SONG PLAYING NOTIFICATION FOR NOW AS IT IS CONFUSING AND ANNOYING FOR FIRST-TIME USERS
				var mobileAndTabletcheck = function() {
					var check = false;
					(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
					return check;
				}
				var requestPermissionAndShowNotificationIfApplicable = function(){
					Notification.requestPermission(function (permission) {

						// Whatever the user answers, we make sure we store the information
						if(!('permission' in Notification)) {
							Notification.permission = permission;
						}

						// If the user is okay, let's create a notification
						if (permission === "granted") {
							if(document.hidden){
								var body =  artistName ? artistName : "";
								body = albumName? body + " - " + albumName: body;
								notification = createNotification(songTitle, body, coverArtBase64  );
							}
						}
					});
				}
				var shouldAskForPermission = function(){
					var isMobile = mobileAndTabletcheck();
					var permissionWasAskedInSession = !!window.lastTimeNotificationRequestWasAskedForTrebble;
					var timeInMillisecSinceLastPermissionAsk = permissionWasAskedInSession ? ((new Date()).getTime() - window.lastTimeNotificationRequestWasAskedForTrebble):null;
					return (!isMobile && !window.isEmbedded && !window.trebble.entryPointUrlHashLoadedPlayerQueue && (!permissionWasAskedInSession || (ASK_FOR_PERMISSION_MULTIPLE_TIMES_IN_SAME_SESSION && timeInMillisecSinceLastPermissionAsk > DEFAULT_TIME_NOTIFICATION_STAY_OPEN_IN_MILLI_SEC)));
				}
				if(shouldAskForPermission()){
					window.lastTimeNotificationRequestWasAskedForTrebble = (new Date()).getTime();
					if(window.navigator && window.navigator.notification && window.navigator.trebbleNotification.confirm){
						var buttonLabels = ["No", "Yes"];
						var confirmCallback = (function(buttonIndex){
							if(buttonIndex ==  2){
								requestPermissionAndShowNotificationIfApplicable();
							}
						}).bind(this);
						var message = "Want to get notifications displaying the song information when Trebble.fm is playing in the background?"
						var customImageUrl ="css/images/notificationExampe_hq.gif";
						var customSize = "383x138";

						navigator.trebbleNotification.confirm("" , confirmCallback, "Show Notification When New Song Starts Playing", buttonLabels,null , null, message, false, customImageUrl,customSize);
					}else{
						requestPermissionAndShowNotificationIfApplicable();
					}
				} 
			}*/
		}
		success(notification);
	}
}

function retrieveScaledCoverArtImages (success, error, opts) {
	if (opts && opts.length < 8) {
		error("Image url is missing!");
	} else {
		var base64Data = null;
		var blurredData = null;
		try{
			var url = opts[7];
			var albumArtImages = (opts.length == 9)?opts[8]: null;
			if(url || albumArtImages){
				var img = new Image();
				if((url && url.indexOf("data:image") != 0) || albumArtImages){
					img.crossOrigin = 'Anonymous';
					url = window.trebble.globalHelpers.getResizeImageUrl(url,  640,640,albumArtImages);
				}
				img.onerror = function(e){
					error(e);
				} 
				img.onload = function(){
					try{
						var canvas = document.createElement('CANVAS');
						var ctx = canvas.getContext('2d');
						canvas.height = this.height;
						canvas.width = this.width;
						ctx.drawImage(this,0,0);
						var dataURL = canvas.toDataURL('image/png');
						canvas = null;
						var p = {};
						base64Data = dataURL;
						p.imageBase64 = dataURL;
						p.radius = 60;
						p.overlay =  'rgba(0,0,0,0.25)';
						var base64Prefix = "data:image/png;base64,";
						var base64DataWithoutPrefix = base64Data;
						if(base64DataWithoutPrefix && base64DataWithoutPrefix.indexOf(base64Prefix) == 0){
							base64DataWithoutPrefix = base64DataWithoutPrefix.substr(base64Prefix.length);
						}
						var onBlurrDataCreated = function(blurredD){
							try{

								blurredData = blurredD;
								if(blurredD && blurredD.indexOf(base64Prefix) == 0){

									blurredData = blurredD.substr(base64Prefix.length);
								}

								var result= {};
								result.screenWidth = opts[1];
								result.screenHeight = opts[2];
								result.regularCovertArtWidth =  opts[3];
								result.regularCovertArtHeigh =  opts[4];
								result.thumbnailWidth =  opts[5];
								result.thumbnailHeight =  opts[6];
								result.isIdifedCoverArt = false;
								result.albumArtBase64RegularSize = base64DataWithoutPrefix;
								result.albumArtBase64BlurScreenSize = blurredData;
								result.albumArtBase64ThumbnailSize = base64DataWithoutPrefix;
								result.albumArtBase64BlurThumbnailSize = blurredData;
								result.url =  url;
								success(result);
							}catch(e){
								error(e);
							}
						};
						if(DISABLE_IMAGE_BLUR_BACKGROUND){
							var result= {};
							result.screenWidth = opts[1];
							result.screenHeight = opts[2];
							result.regularCovertArtWidth =  opts[3];
							result.regularCovertArtHeigh =  opts[4];
							result.thumbnailWidth =  opts[5];
							result.thumbnailHeight =  opts[6];
							result.isIdifedCoverArt = false;
							result.albumArtBase64RegularSize = base64DataWithoutPrefix;
							result.albumArtBase64BlurScreenSize = null;
							result.albumArtBase64ThumbnailSize = base64DataWithoutPrefix;
							result.albumArtBase64BlurThumbnailSize = null;
							result.url =  url;
							success(result);
						}else{
							p.onSuccess = onBlurrDataCreated;
							blurJS($("#imageBlurrer"), p);
						}
					}catch(e){
						console.error(e);
						error(e);
					}
				};
				img.src = url;
			}else{
				success(null);
			}
		}catch(e){
			error(e);
		}
	}
}
var setup = function(){
	if(!window.plugins) {
		window.plugins = {};
	}
	window.plugins.MusicFileReaderPlugin = {
		"retrieveBase64FromUrl": retrieveBase64FromUrl,
		"retrieveScaledCoverArtImages" : retrieveScaledCoverArtImages,
		"updateMetaData" : updateMetaData,
	};
};
if(window.waitForCordovaToLoad){
	document.addEventListener('window.deviceready', setup , false);
}else{
	setup();
}



}


function initCustomEventPolyfill(){
(function () {

	if ( typeof window.CustomEvent === "function" ) return false;

	function CustomEvent ( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent( 'CustomEvent' );
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();
}

function execFunction(resolve, reject, pluginName, pluginOperation, operationParams){
if("plugins" in window){
	var plugin = window.plugins[pluginName];
	var opFunction = plugin[pluginOperation];
	if(opFunction){
		opFunction(resolve, reject,operationParams);
	}
}else{
	reject("Plugins not available")
}

}

window.window.device = {"platform": "browser"};
window.cordovaPolyfill = {"exec": execFunction};

window.isCordovaNativeApp = function(){
return !!window.cordova;
}

/***** RequestAnimationFrame polyfill start ***/


{

const vendors = ['ms', 'moz', 'webkit', 'o']
const af = 'AnimationFrame'
let lastTime = 0

if('performance' in window == false)
	window.performance = {}

if(!Date.now)
	Date.now = () => new Date().getTime()

if ('now' in window.performance == false){
	let nowOffset = Date.now()

	if(performance.timing && performance.timing.navigationStart)
		nowOffset = performance.timing.navigationStart

	window.performance.now = () => Date.now() - nowOffset
}

for(let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	const vendor = vendors[x]
	window.requestAnimationFrame  = window[`${vendor}Request${af}`]
	window.cancelAnimationFrame   = window[`${vendor}Cancel${af}`] || window[`${vendor}CancelRequest${af}`]
}

if(!window.requestAnimationFrame){
	window.requestAnimationFrame = callback =>{
		const currTime    = Date.now()
		const timeToCall  = Math.max(0, 16 - (currTime - lastTime))
		const id          = window.setTimeout(() => callback(currTime + timeToCall), timeToCall)

		lastTime = currTime + timeToCall
		return id
	}
}

if(!window.cancelAnimationFrame)
	window.cancelAnimationFrame = id => clearTimeout(id)

}

// Set initialization flag
window.cordovaPolyfillReady = false;

try{
	


/***** RequestAnimationFrame polyfill end ***/

initCustomEventPolyfill();
initNetworkPluging();
initMusicFileReaderPlugin();
initDialog();
initGoogleAnalytics();
initCamera();

// Mark polyfill as successfully initialized
window.cordovaPolyfillReady = true;
console.log('Cordova Browser Polyfill initialized successfully');

// Dispatch ready event for any code that needs to wait
if (typeof CustomEvent !== 'undefined') {
	window.dispatchEvent(new CustomEvent('cordovaPolyfillReady'));
}

}catch(error){
	console.error('Failed initializing Cordova Polyfill. Error:', error);
	window.cordovaPolyfillReady = false;
}
